<template>
    <!-- Last name input field -->
    <div :class="lastNameInputClass">
        <label class="input__label" for="last-name" v-html="$t('ACCOUNT_FORM_LAST_NAME')"></label>
        <input
            id="last-name"
            name="last-name"
            autocomplete="last-name"
            type="text"
            class="input__field"
            v-model="lastName">

        <!-- Validation -->
        <p class="input__message" v-if="showLastNameRequiredValidationMessage"
            v-text="$t('EMAIL_ADDRESS_FIELD_LAST_NAME')"></p>

        <!-- Validation -->
        <p class="input__message" v-if="showLastNameValidAlphabetStringValidationMessage"
            v-text="$t('EMAIL_ADDRESS_FIELD_NOT_RIGHT')"></p>
    </div>
</template>
<script>
import required from 'vuelidate/src/validators/required';
import { isValidAlphabetString } from '@/validators/StringValidator';

export default {
    name: 'LastNameField',
    props: {
        value: {
            default: null,
            type: String,
        },
    },
    data() {
        return {
            lastName: null,
        };
    },
    computed: {
        isLastNameValid() {
            return !this.$v.lastName.$invalid;
        },

        lastNameInputClass() {
            if (this.lastName === null) return 'input';

            return this.isLastNameValid ? 'input input--success' : 'input input--invalid';
        },

        showLastNameRequiredValidationMessage() {
            return this.lastName !== null && !this.$v.lastName.required;
        },

        showLastNameValidAlphabetStringValidationMessage() {
            if (this.showLastNameRequiredValidationMessage) return false;

            return this.lastName !== null && !this.$v.lastName.isValidAlphabetString;
        },
    },
    mounted() {
        this.lastName = this.value;
    },
    methods: {
        /**
         * Sync with parent component.
         *
         * @returns {void}
         */
        updateInput() {
            this.$emit('input', this.lastName);
            this.$emit('update:validation', this.isLastNameValid);
        },
    },
    validations: {
        lastName: {
            required,
            isValidAlphabetString,
        },
    },
    watch: {
        lastName() {
            this.updateInput();
        },
        value(newValue) {
            if (newValue !== this.lastName) {
                this.lastName = newValue;
            }
        },
    },
};
</script>
